import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enUS from './locales/en-US/common.json';
import es from './locales/es/common.json';

export const defaultNS = 'common';
export const resources = {
  'en-US': { [defaultNS]: enUS },
  es: { [defaultNS]: es },
} as const;

/** Idioma fixo na Fase 1 (sem seletor no front). Estrutura pronta para pt-BR depois. */
const FALLBACK_LNG = 'en-US';

export const LANGUAGE_STORAGE_KEY = 'e-learning-language';

function getInitialLanguage(): string {
  if (typeof window === 'undefined') return FALLBACK_LNG;
  try {
    const stored = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);
    if (stored === 'en-US' || stored === 'es') return stored;
  } catch {
    // ignore (ex.: bloqueio de storage)
  }
  return FALLBACK_LNG;
}

const INITIAL_LNG = getInitialLanguage();

i18n.use(initReactI18next).init({
  resources,
  lng: INITIAL_LNG,
  fallbackLng: FALLBACK_LNG,
  defaultNS,
  ns: [defaultNS],
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
});

export default i18n;
